import { useField } from "formik"

import { DeliveryFulfillmentType, DynamicConfigField, DynamicConfigKey } from "../../form/formTypes"
import { SelectedMainUserState } from "../../../createOrderTypes"
import { DeliveryLocationAutocomplete } from "../deliveryLocation/DeliveryLocationAutocomplete"
import { OtherDeliveryLocationField } from "../deliveryLocation/OtherDeliveryLocationField"

type DeferredDeliveryLocationFieldsProps = Readonly<{
    user: SelectedMainUserState
    deliveryFields: {
        deliveryLocations?: DynamicConfigField
        otherDeliveryLocation?: DynamicConfigField
    }
    showOtherLocationField: boolean
    setShowOtherLocationField: (v: boolean) => void
    hasMeetingLocationRequired: boolean
    defaultButtonClass?: string
}>

export function DeferredDeliveryLocationFields({
    user,
    deliveryFields,
    showOtherLocationField,
    setShowOtherLocationField,
    hasMeetingLocationRequired,
    defaultButtonClass,
}: DeferredDeliveryLocationFieldsProps) {
    const [{ value: deliveryType = "" }] = useField<DeliveryFulfillmentType>(DynamicConfigKey.DELIVERY_TYPE)

    const showLocation =
        (deliveryType === DeliveryFulfillmentType.DELIVERY || hasMeetingLocationRequired) &&
        deliveryFields.deliveryLocations
    const isMeetingLocation = hasMeetingLocationRequired && deliveryType !== DeliveryFulfillmentType.DELIVERY

    if (!showLocation) return null

    return (
        <>
            <DeliveryLocationAutocomplete
                userId={user.userId}
                config={deliveryFields.deliveryLocations!}
                isMeetingLocation={isMeetingLocation}
            />
            {deliveryFields.otherDeliveryLocation && (
                <OtherDeliveryLocationField
                    config={deliveryFields.otherDeliveryLocation}
                    showOtherLocationField={showOtherLocationField}
                    setShowOtherLocationField={setShowOtherLocationField}
                    defaultButtonClass={defaultButtonClass}
                    isMeetingLocation={isMeetingLocation}
                />
            )}
        </>
    )
}
